if (!customElements.get('lhub-discord-field')) {
  customElements.define(
    'lhub-discord-field',
    class LhubDiscordField extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        this.errorMessage = this.querySelector('.form__message');
        this.productForm = this.closest('product-form');

        if (!this.required) return;

        this.input.addEventListener('input', this.onInput.bind(this));
        this.syncPaymentButton();
      }

      get required() {
        return this.dataset.required === 'true';
      }

      get filled() {
        return this.input.value.trim() !== '';
      }

      onInput() {
        if (this.filled) this.toggleError(false);
        this.syncPaymentButton();
      }

      // The dynamic checkout button submits straight to checkout on its own and
      // never reaches the submit listener below, so it stays hidden until filled.
      syncPaymentButton() {
        this.productForm?.classList.toggle('lhub-discord-pending', !this.filled);
      }

      toggleError(show) {
        this.errorMessage.classList.toggle('hidden', !show);
        this.input.setAttribute('aria-invalid', show);
      }

      validate() {
        if (!this.required || this.filled) return true;

        this.toggleError(true);
        this.input.focus();
        return false;
      }
    }
  );

  // The product form carries `novalidate`, so `required` alone blocks nothing.
  // Dawn registers its own submit listener on the form; capturing on document
  // runs ahead of it regardless of registration order.
  document.addEventListener(
    'submit',
    (event) => {
      const field = event.target.querySelector?.('lhub-discord-field[data-required="true"]');
      if (!field || field.validate()) return;

      event.preventDefault();
      event.stopPropagation();
    },
    true
  );
}
